import {
  MessagesSquare,
  MessageSquare,
  Users,
  ThumbsUp,
  ThumbsDown,
  Globe,
  Building2,
  FileText,
} from 'lucide-react'
import { useAdminStats } from '@/hooks/useAdminStats'
import StatCard from './StatCard'
import LoadingSpinner from '@/components/admin/shared/LoadingSpinner'

export default function OverviewPage() {
  const { data: stats, isLoading, error } = useAdminStats()

  if (isLoading) return <LoadingSpinner />
  if (error) return <p className="text-red-500 text-sm py-8 text-center">Failed to load stats.</p>
  if (!stats) return null

  return (
    <div className="space-y-8">
      <section>
        <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Usage</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <StatCard label="Total Conversations" value={stats.total_conversations} icon={MessagesSquare} color="blue" />
          <StatCard label="Total Messages"       value={stats.total_messages}       icon={MessageSquare}  color="blue" />
          <StatCard label="Unique Users"         value={stats.unique_users}         icon={Users}          color="blue" />
        </div>
      </section>

      <section>
        <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Feedback</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <StatCard label="Positive Feedback" value={stats.feedback_positive} icon={ThumbsUp}   color="green" />
          <StatCard label="Negative Feedback" value={stats.feedback_negative} icon={ThumbsDown} color="red"   />
        </div>
      </section>

      <section>
        <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">Filter Database</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <StatCard label="Jurisdictions"         value={stats.filter_jurisdictions}   icon={Globe}     color="gray" />
          <StatCard label="Publishing Authorities" value={stats.filter_pub_authorities} icon={Building2} color="gray" />
          <StatCard label="Documents"             value={stats.filter_documents}       icon={FileText}  color="gray" />
        </div>
      </section>
    </div>
  )
}
